import * as types from 'store/actions/types';
import produce from 'immer';

export const INITIAL_STATE = {
	loading: true,
	error: false,
	data: [],
	columns: [],
	deleteItem: {
		success: false,
		error: false
	},
	options: {
		pages: 0,
		total_results: 0,
		sorted: undefined,
		filters: {
			query: '',
			filterUrlQuery: ''
		}
	}
};

export default (state = INITIAL_STATE, action) =>
	produce(state, (draft) => {
		switch (action.type) {
			// ****************** CLEAR DATA ******************
			case types.CLEAR_STATE:
				return { ...INITIAL_STATE };

			// *************** FETCH SEASONS ***************
			case types.FETCH_SEASONS_LOADING:
				draft.loading = true;
				draft.error = false;
				break;

			case types.FETCH_SEASONS_SUCCESS:
				draft.loading = false;
				draft.data = action.payload.data;
				draft.columns = action.payload.input.columns;
				draft.options.pages = action.payload.pages;
				draft.options.total_results = action.payload.recordsFiltered;
				break;

			case types.FETCH_SEASONS_ERROR:
				draft.error = action.payload;
				break;

			// *************** DELETE SEASON ***************
			case types.DELETE_SEASON_LOADING:
				draft.deleteItem.success = false;
				draft.deleteItem.error = false;
				break;

			case types.DELETE_SEASON_SUCCESS:
				draft.deleteItem.success = action.payload;
				draft.deleteItem.error = false;
				break;

			case types.DELETE_SEASON_ERROR:
				draft.deleteItem.error = action.payload;
				break;

			// *************** SAVE SORTING OPTIONS ***************
			case types.SAVE_SEASONS_TABLE_SORTING:
				draft.options.sorted = action.payload;
				break;

			// *************** SET SEARCH QUERY ***************
			case types.SET_SEASONS_SEARCH_QUERY:
				draft.options.filters.query = action.payload;
				break;

			// --------------- FILTERS ---------------
			// *************** SET FILTER URL QUERY ***************
			case types.SET_FILTER_URL_QUERY:
				draft.options.filters.filterUrlQuery = action.payload;
				break;

			// *************** CLEAR FILTERS ***************
			case types.CLEAR_FILTERS:
				draft.options.filters.filterUrlQuery = '';
				break;

			default:
				return state;
		}
	});
